import { Facebook, Instagram } from "lucide-react";

export const SOCIALS = [
  {
    name: "Facebook",
    url: "https://www.facebook.com/profile.php?id=61574877909041",
    icon: (props) => <Facebook {...props} />,
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/jeremy.spear",
    icon: (props) => <Instagram {...props} />,
  },
  {
    name: "TikTok",
    url: "https://www.tiktok.com/@cbcontractor361",
    icon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" width={props.size || 16} height={props.size || 16} {...props}>
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.91a8.16 8.16 0 0 0 4.77 1.52V7a4.85 4.85 0 0 1-1.84-.31z" />
      </svg>
    ),
  },
  {
    name: "Houzz",
    url: "https://www.houzz.com/professionals/coastalbendcontractor",
    icon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" width={props.size || 16} height={props.size || 16} {...props}>
        <path d="M19 24H5V0h3.4v8.5l7.2 4.16V0H19v24z" />
      </svg>
    ),
  },
  {
    name: "Yelp",
    url: "https://www.yelp.com/biz/coastal-bend-contractors-corpus-christi",
    icon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" width={props.size || 16} height={props.size || 16} {...props}>
        <path d="M20.16 12.594l-1.91-.606c-1.398-.44-2.097.965-1.396 2.215l1.122 1.998c.392.692.97.971 1.476.732.18-.07 1.844-1.066 2.158-2.146.41-1.396-.378-1.844-1.448-2.193zm-1.572 4.92l-1.625-1.227c-1.146-.86-2.408.082-2.07 1.479l.515 2.219c.18.79.683 1.184 1.225 1.072.215-.039 2.135-.65 2.832-1.521.911-1.146.358-1.733-.877-2.022zm-7.305-7.762L11.121.93C11.013.358 10.598 0 10.063 0c-.18 0-2.658.197-4.324 1.215C4.085 2.236 4.605 3.273 5.32 3.871l5.105 4.31c1.146.97 2.444.214 1.857-1.43zM10.605 13.34c.181-.467.073-.967-.287-1.225-.143-.107-2.371-1.57-4.451-1.69C4.18 10.318 4 11.43 4.072 12.21c0 .215.215 2.121 1 3.535.395.715 1.039.93 1.609.539zm.825 1.832c-.43-.215-.965-.107-1.32.252l-2.121 2.18c-.539.555-.357 1.488.287 1.881.18.107 1.875 1.107 3.575.997 1.218-.066 1.32-.93.965-1.594z" />
      </svg>
    ),
  },
];

export default function SocialLinks({ size = 16, variant = "icon", className = "" }) {
  if (variant === "labeled") {
    return (
      <ul className={`space-y-2.5 ${className}`}>
        {SOCIALS.map((s) => (
          <li key={s.name}>
            <a
              href={s.url}
              target="_blank"
              rel="noopener noreferrer me"
              className="inline-flex items-center gap-2.5 hover:text-white transition-colors"
              style={{ color: "var(--text-muted)" }}
              data-testid={`social-${s.name.toLowerCase()}`}
            >
              <span
                className="w-8 h-8 rounded-md flex items-center justify-center transition-colors"
                style={{ background: "rgba(212,163,115,0.1)", color: "var(--accent)" }}
              >
                <s.icon size={14} />
              </span>
              <span>{s.name}</span>
            </a>
          </li>
        ))}
      </ul>
    );
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {SOCIALS.map((s) => (
        <a
          key={s.name}
          href={s.url}
          target="_blank"
          rel="noopener noreferrer me"
          aria-label={s.name}
          title={s.name}
          data-testid={`social-${s.name.toLowerCase()}`}
          className="w-9 h-9 rounded-md flex items-center justify-center transition-all hover:-translate-y-0.5"
          style={{
            background: "rgba(255,255,255,0.04)",
            color: "var(--text-muted)",
            border: "1px solid rgba(255,255,255,0.08)",
          }}
        >
          <s.icon size={size} />
        </a>
      ))}
    </div>
  );
}
